module.exports = __webpack_public_path__ + "static/media/accept_trade.cffb2a14.svg";